export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: Record<string, unknown> = {},
  children: (Node | string)[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(props)) {
    if (key === "className") node.className = String(value);
    else if (key === "text") node.textContent = String(value);
    else if (key === "html") node.innerHTML = String(value);
    else if (key.startsWith("on") && typeof value === "function") {
      node.addEventListener(key.slice(2).toLowerCase(), value as EventListener);
    } else if (value === false || value === null || value === undefined) {
      // skip
    } else if (key === "disabled" || key === "hidden" || key === "checked") {
      (node as HTMLElement & Record<string, unknown>)[key] = Boolean(value);
    } else {
      node.setAttribute(key, String(value));
    }
  }
  for (const child of children) {
    node.append(child instanceof Node ? child : document.createTextNode(child));
  }
  return node;
}

export function announce(message: string) {
  const live = document.getElementById("sr-announcer");
  if (live) live.textContent = message;
}

export function setSyncPill(status: string) {
  const pill = document.getElementById("sync-status");
  if (!pill) return;
  pill.textContent = status;
  pill.classList.toggle("status-syncing", status === "Syncing");
}

export function setOfflineBanner(offline: boolean) {
  const banner = document.getElementById("offline-banner");
  if (!banner) return;
  banner.hidden = !offline;
}

export function formatWhen(iso: string): string {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}
